const HSB_AUTH_COOKIE = "HSB_AUTH_COOKIE";

export { HSB_AUTH_COOKIE };
